export enum INVITATION_STATUS {
  pending = 'pending',
  accepted = 'accepted',
  declined = 'declined',
  canceled = 'canceled',
}
